import fetcher from '../fetcher';
import { MasterData } from './master-data';

export type SearchGoLiveParams = {
	startDate: string;
	endDate: string;
	plafonTypeId: number;
	orderSourceId: number;
	divisionId?: number;
	frmId?: number;
	fbdhId?: number;
	ccaId?: number;
	ccdhId?: number;
};

export type SearchGoLiveResponse = {
	totalEstimatedNtf: number;
	totalUnits: number;
	items: {
		pipelineGoLiveId: number;
		pipelineNo: string;
		prospectPlafonId: number;
		prospectId: string;
		napNo: string;
		customer: MasterData;
		plafonType: string;
		limitType: string;
		orderSource: string;
		fbdhName: string;
		frmName: string;
		currentProgress: string;
		estimatedGoliveDate: string;
		assetType: string;
		fundingSchemeId: number;
		fundingScheme: string;
		requestedLimit: number;
		approvedLimit: number;
		estimatedNtf: number;
		units: number;
		lastModifiedAt: string;
		lastModifiedBy: number;
		lastModifiedByName: string;
		status: string;
	}[];
};

export const searchGolive = (body: SearchGoLiveParams) => {
	return fetcher<SearchGoLiveResponse>({
		api: '/pipeline-golive/search',
		body,
	});
};

export type SubmitGolivePayload = {
	prospectPlafonId: number;
	prospectId: string;
	progressDetailId: number;
	estimatedGoliveDate: string;
	estimatedNtf: number;
	brandDetails: {
		brandDetailId: number;
		brandId: number;
		brandTypeId: number;
		unit: number;
		amount: number;
	}[];
	fundingSchemeId: number;
	action: 'Draft' | 'Update';
	isFinal?: boolean;
};

export const submitGolive = (body: SubmitGolivePayload) => {
	return fetcher<{
		messages: string;
		finalPipelineGoLiveId: number;
		pipelineGoLiveId: number;
	}>({
		api: '/pipeline-golive/submit',
		body,
	});
};

export type GetGoliveDetailParam = {
	prospectPlafonId: number;
	prospectId: string;
};

export type GetGoliveDetailResponse = {
	pipelineGoLiveId: number;
	prospectPlafonId: number;
	prospectId: string;
	napNo: string;
	customer: MasterData;
	plafonType: MasterData;
	limitType: MasterData;
	orderSource: MasterData;
	requestedLimit: number;
	approvedLimit: number;
	fbdh: MasterData;
	frm: MasterData;
	currentProgress: string;
	progressDetail: MasterData;
	progressDetailOptions: MasterData[];
	estimatedGoliveDate: string;
	estimatedNtf: number;
	assetTypes: MasterData[];
	assetTypeOptions: MasterData[];
	fundingScheme: MasterData;
	fundingSchemeOptions: MasterData[];
	brandDetails: {
		brandDetailId: number;
		brandId?: number;
		brandName: string;
		brandTypeId: number;
		brandTypeName: string;
		unit: number;
		amount: number;
	}[];
	status: string;
	pipelineGoLiveHistory?: {
		items: {
			approvedLimit: number;
			assetType: string;
			currentProgress: string;
			customer: MasterData;
			id: string;
			value: string;
			estimatedGoliveDate: string;
			estimatedNtf: number;
			fbdhName: string;
			finalPipelineGoLiveId: number;
			frmName: string;
			fundingScheme: string;
			fundingSchemeId: number;
			lastModifiedAt: string;
			lastModifiedBy: string;
			lastModifiedByName: string;
			limitType: string;
			napNo: string;
			orderSource: string;
			pipelineGoLiveId: number;
			plafonType: string;
			prospectId: string;
			prospectPlafonId: number;
			requestedLimit: number;
			status: string;
			units: number;
		}[];
		totalEstimatedNtf: number;
		totalUnits: number;
	};
};

export const getGoliveDetail = (body: GetGoliveDetailParam) => {
	return fetcher<GetGoliveDetailResponse>({
		api: '/pipeline-golive/get-detail',
		body,
	});
};

export const getGoliveBrand = (pipelineGoLiveId: number) => {
	return fetcher<
		[
			{
				brandDetailId: number;
				brandId: number;
				brandName: string;
				brandTypeId: number;
				brandTypeName: string;
				unit: number;
				amount: number;
			},
		]
	>({
		api: '/pipeline-golive/get-brand-detail',
		body: {
			pipelineGoLiveId,
		},
	});
};

export const finalizeGolive = (finalPipelineGoLiveId: number) => {
	return fetcher({
		api: '/pipeline-golive/finalize',
		body: {
			finalPipelineGoLiveId,
		},
	});
};

export const getGoliveTodoCount = () => {
	return fetcher<number>({
		api: '/pipeline-golive/get-things-todo',
	});
};
